import { FiAIAssistanceService } from '../../../shared/fi-ai-assistance/fi-ai-assistance.service';
import { FiAIAssistanceType } from '@fi-shared/fi-ai-assistance/fi-a-i-assistance-type';

export const FiDocumentStatesResolveRecentAIRequests = [
    FiAIAssistanceService,
    FiDocumentStatesResolveRecentAIRequestsFunc,
];

export function FiDocumentStatesResolveRecentAIRequestsFunc(fiAIAssistanceService: FiAIAssistanceService) {
    return fiAIAssistanceService.getRecentAIRequests(FiAIAssistanceType.Document);
}
